export default __webpack_public_path__ + "static/char-21-anr-98f923544ce2c279fced39f669c742c5.webp";